const groupOption = function () {
  return {
    labelWidth: 120,
    emptyBtn: false,
    submitBtn: false,
    column: [{
        label: '名称',
        span: 18,
        prop: 'name',
        // disabled: true,
        rules: [{
          required: true,
          message: '请输入名称',
          trigger: 'change'
        }]
      },
      {
        label: '负责人',
        span: 18,
        prop: 'chargePerson',
        formslot: true,
        // disabled: true,
        rules: [{
          required: true,
          message: '请选择负责人',
          trigger: 'change'
        }]
      },
      {
        label: '访客有车',
        span: 18,
        prop: 'appointmentCarNotifyFlag',
        formslot: true,
        // disabled: true,
        rules: [{
          required: true,
          message: '请选择',
          trigger: 'change'
        }]
      },
      {
        label: '访客无车',
        span: 18,
        prop: 'appointmentNoCarNotifyFlag',
        formslot: true,
        // disabled: true,
        rules: [{
          required: true,
          message: '请选择',
          trigger: 'change'
        }]
      },
      {
        label: '负责管辖区域',
        span: 18,
        prop: 'region',
        formslot: true,
        // disabled: true,
        // rules: [{
        //   required: true,
        //   message: '请选择负责管辖区域',
        //   trigger: 'change'
        // }]
      }
    ]
  }
}

export default groupOption